import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

import { Avatar } from './avatar.entities';

@Component({
  selector: 'pp-avatar',
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  readonly avatar = input<Avatar>();
  readonly firstName = input<string>();
  readonly size = input<'small' | 'large'>('small');

  @HostBinding('class')
  get classes(): string {
    return this.size();
  }

  get firstLetter(): string {
    return (this.firstName()?.charAt(0) || '').toUpperCase();
  }
}
